const fullscreenEditor = {
  namespaced: true,
  state: {
    show: false,
    progress: 0,
    type: 1, // 1:编辑 2:批注
  },
  getters: {
    show: (state) => state.show,
    progress: (state) => state.progress,
    type: (state) => state.type,
  },
  mutations: {
    setShow(state, show) {
      state.show = show
    },
    setProgress(state, progress) {
      state.progress = progress
    },
    setType(state, type) {
      state.type = type
    },
  },
  actions: {
    show({ commit }, progress) {
      commit('setProgress', progress)
      commit('setShow', true)
    },
    hide({ commit }) {
      commit('setShow', false)
    },
    setType({ commit }, type) {
      commit('setType', type)
    },
  },
}

export default fullscreenEditor
